import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const DonateSuccess: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container
      maxWidth={false}
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `url('https://storage.googleapis.com/genibot2.appspot.com/images/ZV4qJzg5hbFPZR5MPnMH.png?uid=7bc0f60d-bb20-4ef9-a737-19bb551b7c1d') center/cover no-repeat`,
        position: 'relative',
      }}
    >
      {/* Glassy Overlay */}
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          background: 'rgba(255, 255, 255, 0.7)', // Light overlay for readability
        }}
      />

      {/* Content */}
      <Box
        sx={{
          position: 'relative',
          textAlign: 'center',
          color: '#5D4037', // Deep brown for elegance
          p: 5,
          borderRadius: 3,
          maxWidth: 800,
          backdropFilter: 'blur(1px)',
          background: 'rgba(255, 245, 230, 0.6)', // Soft beige-glass effect
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
        }}
      >
        <Box sx={{ mb: 2 }}>
          <img src="/images/donation_success.png" alt="Logo" style={{ width: 90, height: 90 }} />
        </Box>

        <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', letterSpacing: 1 }}>
          🎉 Thank You for Your Generous Support!
        </Typography>

        <Typography variant="body1" sx={{ mb: 3, fontSize: '1.2rem' }}>
          Your donation to <strong>Hope Beyond International</strong> brings comfort, dignity, and care
          to those who need it most. Your kindness helps us provide **compassionate, holistic**
          end-of-life support to individuals and families facing serious illnesses.
        </Typography>

        <Typography
          variant="body2"
          sx={{ mb: 4, fontSize: '1rem', fontStyle: 'italic', opacity: 0.9 }}
        >
          Together, we are making a real difference. 💙
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button
            variant="contained"
            sx={{
              px: 3,
              py: 1,
              fontSize: '1rem',
              borderRadius: 2,
              backgroundColor: '#6D4C41', // Brown color matching the Donate button
              color: '#fff',
              '&:hover': { backgroundColor: '#5D4037' }, // Darker brown on hover
            }}
            onClick={() => navigate('/')}
          >
            Return Home
          </Button>
          <Button
            variant="outlined"
            sx={{
              px: 3,
              py: 1,
              fontSize: '1rem',
              borderRadius: 2,
              color: '#6D4C41',
              borderColor: '#6D4C41',
              '&:hover': { backgroundColor: 'rgba(93, 64, 55, 0.1)' },
            }}
            onClick={() => navigate('/about')}
          >
            Learn More
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default DonateSuccess;
